import React, { useEffect } from "react";
//import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Routes, Route } from "react-router-dom";
import { Navigate } from "react-router-dom";
// Context
import { useAuth } from "./context/AuthContext";
import { useSettings } from "./context/SettingsContext";
import { useFavicon } from "./hooks/useFavicon";

// Pages – Publike
import Login from "./pages/Login";
import KerkoStokShpejt from "./pages/KerkoStokShpejt";

// Pages – Me layout
import Dashboard from "./pages/Dashboard";
import Produkte from "./pages/Produkte";
import Shitje from "./pages/Shitje";
import HistorikuShitjeve from "./pages/HistorikuShitjeve";
import Raporte from "./pages/Raporte";
import Harxhimet from "./pages/Harxhimet";
import Perdoruesit from "./pages/Perdoruesit";

// CRUD pages – Konfigurime
import Kategorite from "./pages/Kategorite";
import Madhesite from "./pages/Madhesite";
import Ngjyrat from "./pages/Ngjyrat";
import Furnizuesit from "./pages/Furnizuesit";
import Stoku from "./pages/Stoku";
import LlojetHarxhimeve from "./pages/LlojetHarxhimeve";
import KthimProdukti from "./pages/KthimProdukti";
import Lokacionet from "./pages/Lokacionet";
import Settings from "./pages/Settings";
import PorositeOnline from "./pages/PorositeOnline";

// Komponentë Layout & Global
import Layout from "./components/Layout";
import LoadingSpinner from "./components/LoadingSpinner";
import IOSInstallPrompt from "./components/IOSInstallPrompt"; // Shto këtë skedar

// Komponent për mbrojtje të rrotave
const PrivateRoute = ({ children, allowedRoles }) => {
  const { roli, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!roli) {
    return <Navigate to="/login" />;
  }

  if (!allowedRoles.includes(roli)) {
    return <Navigate to="/kerkimi-stok" />;
  }

  return children;
};

function App() {
  const { getShopName, logoUrl } = useSettings();

  // Update document title with shop name
  useEffect(() => {
    const shopName = getShopName();
    // Përditëso title vetëm nëse ka emër, përndryshe lexo nga manifest.json
    if (shopName) {
      document.title = shopName;
    } else {
      // Lexo nga manifest.json ose përdor default
      fetch('/manifest.json')
        .then(res => res.json())
        .then(manifest => {
          document.title = manifest?.short_name || manifest?.name?.split(' – ')[0] || 'Shop';
        })
        .catch(() => {
          document.title = 'Shop';
        });
    }
  }, [getShopName]);

  // Update favicon with logo and shop name
  useFavicon(logoUrl, getShopName());

  return (
    <>
      {/* Udhëzim për iOS instalim */}
      <IOSInstallPrompt />
      <Routes>
        {/* Publike */}
        <Route path="/login" element={<Login />} />
        <Route
          path="/kerkimi-stok"
          element={
            <Layout>
              <KerkoStokShpejt />
            </Layout>
          }
        />

        {/* Shitës */}
        <Route
          path="/shitje"
          element={
            <PrivateRoute allowedRoles={["shites", "menaxher", "admin"]}>
              <Layout>
                <Shitje />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/historiku-shitjeve"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <Layout>
                <HistorikuShitjeve />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/porosite-online"
          element={
            <PrivateRoute allowedRoles={["admin", "online"]}>
              <Layout>
                <PorositeOnline />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/kthimprodukti"
          element={
            <PrivateRoute allowedRoles={["shites", "menaxher", "admin"]}>
              <Layout>
                <KthimProdukti />
              </Layout>
            </PrivateRoute>
          }
        />
        {/* Menaxher */}
        <Route
          path="/raporte"
          element={
            <PrivateRoute allowedRoles={["menaxher", "admin"]}>
              <Layout>
                <Raporte />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/harxhime"
          element={
            <PrivateRoute allowedRoles={["menaxher", "admin"]}>
              <Layout>
                <Harxhimet />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/stoku"
          element={
            <PrivateRoute allowedRoles={["menaxher", "admin"]}>
              <Layout>
                <Stoku />
              </Layout>
            </PrivateRoute>
          }
        />

        {/* Admin */}
        <Route
          path="/"
          element={
            <PrivateRoute allowedRoles={["shites", "menaxher", "admin"]}>
              <Layout>
                <Dashboard />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/produkte"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <Layout>
                <Produkte />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/perdoruesit"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <Layout>
                <Perdoruesit />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/kategorite"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <Layout>
                <Kategorite />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/madhesite"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <Layout>
                <Madhesite />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/ngjyrat"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <Layout>
                <Ngjyrat />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/furnizuesit"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <Layout>
                <Furnizuesit />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/lloj-harxhimi"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <Layout>
                <LlojetHarxhimeve />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/lokacionet"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <Layout>
                <Lokacionet />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <Layout>
              <Settings />
            </Layout>
          }
        />
      </Routes>
    </>
  );
}

export default App;
